import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputImageInterface } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-input-image',
  imports: [
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './input-image.html',
  styleUrl: './input-image.css',
})
export class InputImage {
  @Input()
  public formData!: InputImageInterface;

  public selectedFilePreviews: {
    file: File,
    url: string,
  }[] = [];

  public onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files: File[] = input.files ? Array.from(input.files) : [];

    this.revokePreviewUrls();

    this.selectedFilePreviews = files.map((file: File) => ({
      file,
      url: URL.createObjectURL(file),
    }));


    if (this.formData.formGroup) {
      this.formData.formGroup.get(this.formData.id)?.setValue(files);
      this.formData.formGroup.get(this.formData.id)?.markAsDirty();
      this.formData.formGroup.get(this.formData.id)?.updateValueAndValidity();
    }

    if (this.formData.onInput) {
      this.formData.onInput(event);
    }
  }

  private revokePreviewUrls(): void {
    for (const preview of this.selectedFilePreviews) {
      URL.revokeObjectURL(preview.url);
    }

    this.selectedFilePreviews = [];
  }
}